import React, { PureComponent } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.scss'
import { t } from 'helpers/localization'
import { default as TD } from '@wg/wows-react-uikit/TooltipDecorator'
import { ButtonPromo, StepCSSTransitionGroup, Tooltip, TooltipBody, TooltipHeader } from '@wg/wows-react-uikit'
import { OpenSidebarButton } from '../ViewSupply/ViewSupply'
import styles from './ViewPromo.scss'
import { ClanRec2IsEnabled, ClanRecIsEnabled, anyClanRecIsEnabled } from '../../helpers/common'
import DivTooltip from '@wg/wows-react-uikit/DivTooltip'
import settings from "settings";

export type ViewPromo_Props = {
    NavigateToSlide: (index: number) => void,
    goToFirstSlide: () => void,
    goToSecondSlide: () => void,
    SetSliderRef: (ref: any) => void,
    navigateToRecommendations: () => void,
    beforeChange: (curIndex: any, nextIndex: number) => void,
    afterChange: (index: number) => void,

    promoInitialSlide: number,
    clanId: number | null,
    buildings: any,
    activeSlide: number,
}

const BONUS_CATEGORIES = [
    {
        title: t('Клан'),
        buildings: [
            'treasury',
            'headquarters',
        ],
    },
    {
        title: t('Корабли'),
        buildings: [
            'dry_dock',
            'shipbuilding_factory',
        ],
    },
    {
        title: t('Опыт'),
        buildings: [
            'university',
            'design_department',
            'academy',
        ],
    },
    {
        title: t('Ресурсы'),
        buildings: [
            'steel_yard',
            'coal_yard',
            'paragon_yard',
        ],
    },
    {
        title: t('Достижения'),
        buildings: [
            'monument',
            'vessels',
            'ships',
        ],
    },
]

export type IBackground = {
    isOpened: boolean
}

class Background extends PureComponent<IBackground, any> {
    render() {
        return (
            <div className={`${styles.background}`} key={'background'}>
                <div className={`${styles.backgroundBlur} ${this.props.isOpened ? styles.backgroundBlurTransparent : ''}`} key={'backgroundBlur'} />
                <div className={`${styles.cloud} ${styles.leftClouds} ${this.props.isOpened ? styles.leftCloudsOpened : ''}`} />
                <div className={`${styles.cloud} ${styles.leftCloudsHigher} ${this.props.isOpened ? styles.leftCloudsHigherOpened : ''}`} />
                <div className={`${styles.cloud} ${styles.rightClouds} ${this.props.isOpened ? styles.rightCloudsOpened : ''}`} />
                <div className={`${styles.cloud} ${styles.rightCloudsHigher} ${this.props.isOpened ? styles.rightCloudsHigherOpened : ''}`} />
            </div>
        )
    }
}

const allNull = (array: Array<any>) => {
    if (!array || array.length === 0) {
        return true
    } else {
        let isNull = true

        array.forEach((item) => {
            if (item !== null) {
                isNull = false
            }
        })

        return isNull
    }
}

const NextArrow = (props: any) => {
    return (
        <div
            className={props.className}
            onClick={props.showNext}
        />
    )
}

const PrevArrow = (props: any) => {
    return (
        <div
            className={props.className}
            onClick={props.showPrev}
        />
    )
}

const Resourse = TD()((props: any) => (
    <div className={`${styles.resourseIcon} ${styles[props.icon]}`} />
))

const getBonusTooltip = (building) => {
    const level = building.levels[building.level]
    let bonus = (!level.meta.totalBonus || level.meta.totalBonus === '') ? level.meta.function : level.meta.totalBonus
    return (
        <Tooltip>
            <TooltipHeader>
                <div className={styles.bonusTooltip}>
                    {level.title}
                </div>
            </TooltipHeader>
            <TooltipBody>
                {bonus}
            </TooltipBody>
        </Tooltip>
    )
}

const getBonuses = (props) => {

    return BONUS_CATEGORIES.filter(category => {
        const availableBuildings = []
        category.buildings.forEach(buildingId => {
            if (props.buildings[buildingId] && props.buildings[buildingId].level > 0) {
                availableBuildings.push(buildingId)
            }
        })
        return availableBuildings.length > 0
    }).map((category, index) => {
        return (
            <div className={styles.bonusCategory} key={`Bonus${index}`}>
                <div className={styles.bonusCategoryTitle}>{category.title}</div>
                <div className={styles.bonusCategoryIcons}>
                    {category.buildings.filter(buildingId => {
                        if (props.buildings[buildingId]){
                            return props.buildings[buildingId].level > 0
                        }
                    }).map(buildingId => {
                        const building = props.buildings[buildingId]
                        return (
                            <DivTooltip
                                key={buildingId}
                                tooltipBody={getBonusTooltip(building)}
                            >
                                <div className={styles[`bonusCategoryIcon_${buildingId}`]} />
                            </DivTooltip>
                        )
                    })}
                </div>
            </div>
        )
    })
}

class ViewPromo extends PureComponent<ViewPromo_Props, any> {


    _getFirstSlide = () => {

        const bonuses = this.props.clanId && this.props.buildings ? getBonuses(this.props) : null

        return (
            <div className={styles.slide}>
                <div className={styles.slideContentWrapper}>
                    <StepCSSTransitionGroup level={2}>
                        <div className={styles.titleWrapper}>
                            <h1 className={styles.title}>{t('Зачем нужен клан?')}</h1>
                        </div>
                    </StepCSSTransitionGroup>
                    <StepCSSTransitionGroup level={3}>
                        <div className={styles.bonucesWrapper}>
                            <div className={styles.bonus}>
                                <h3 className={styles.secondTitle}>
                                    {t('Скидки и бонусы')}
                                </h3>
                                <div className={`${styles.bonusIcon} ${styles.bonusIconCoins}`} />
                                <p className={styles.bonusDescription}>
                                    {t('Просто играйте в ваши любимые типы боя и получайте дополнительный опыт за бой, скидки на прокачиваемые корабли и многие другие бонусы!')}
                                </p>
                            </div>
                            <div className={styles.bonus}>
                                <h3 className={styles.secondTitle}>
                                    {t('Командная игра')}
                                </h3>
                                <div className={`${styles.bonusIcon} ${styles.bonusIconTeamPlay}`} />
                                <p className={styles.bonusDescription}>
                                    {t('С помощью клана вы не только найдете себе товарищей для игры в отряде, но и получите доступ к особому типу боя ― Клановые бои.')}
                                </p>
                            </div>
                            <div className={styles.bonus}>
                                <h3 className={styles.secondTitle}>
                                    {t('Уникальные награды')}
                                </h3>
                                <div className={`${styles.bonusIcon} ${styles.bonusIconUniq}`} />
                                <p className={styles.bonusDescription}>
                                    {t('Играйте в клане, получайте ресурсы и обменивайте их на уникальные корабли и другое полезное имущество!')}
                                </p>
                            </div>
                        </div>
                    </StepCSSTransitionGroup>
                    {bonuses ? (
                        <div className={styles.wide}>
                            <StepCSSTransitionGroup level={4}>
                                <div className={styles.activeBonusTitleWrapper}>
                                    <h2 className={styles.secondTitle}>{t('Активные бонусы вашего клана')}</h2>
                                </div>
                                <div className={styles.bonusCategoryRow}>
                                    {bonuses}
                                </div>
                            </StepCSSTransitionGroup>
                        </div>
                    ) : null}
                    {anyClanRecIsEnabled ? (
                        <StepCSSTransitionGroup level={5}>
                            <ButtonPromo
                                onClick={this.props.clanId ? this.props.goToSecondSlide : this.props.navigateToRecommendations}
                                isCenter={true}
                            >
                                {this.props.clanId ? t('О клановой базе') : t('Хочу в клан')}
                            </ButtonPromo>
                        </StepCSSTransitionGroup>
                    ) : null}
                </div>


            </div>
        )
    }

    _getSecondSlide = () => {
        return this.props.clanId ? this._getSupplyInfoSlide() : this._getRecommendationsSlide()
    }


    _getSupplyInfoSlide = () => {
        return (
            <div className={styles.slide}>
                <OpenSidebarButton className={'SidebarButtonArrowTarget'} />
                <div className={styles.slideContentWrapper}>
                    <div className={styles.titleWrapper}>
                        <h1 className={styles.title} onClick={this.props.goToFirstSlide}>{t('Обновленная клановая база')}</h1>
                    </div>
                    <div className={styles.descriptionBlocksWrapper}>
                        <div className={styles.descriptionBlockLeft}>
                            <h2 className={styles.descriptionBlockTitle}>{t('С друзьями к победе')}</h2>
                            <p className={`${styles.descriptionBlockText} BlockA`}>
                                {t('Хотите быть в курсе достижений товарищей по клану?')}&nbsp;
                                {t('На вкладке «Состав клана» вы можете посмотреть не только имена и должности всех соклановцев, но также их статистику по каждому типу боя и количество заработанной нефти.')}
                            </p>
                        </div>
                        <div className={`${styles.descriptionBlockRight} BlockB`}>
                            <h2 className={styles.descriptionBlockTitle}>{t('Новые здания, новые возможности!')}</h2>
                            <p className={styles.descriptionBlockText}>
                                {t('Еще больше бонусов!')}&nbsp;
                                {t('Дополнительный опыт для командира, а также увеличенная добыча стали и угля.')}&nbsp;
                                {t('Здания теперь компактно отображены справа и вы легко сможете следить за состоянием базы.')}
                            </p>
                        </div>
                    </div>
                    <div className={styles.updatesWrapper}>
                        <h2 className={styles.descriptionBlockTitle}>{t('Ресурсы и награды')}</h2>
                        <p className={styles.descriptionBlockText}>
                            {t('В World of Warships есть различные ресурсы, которые можно обменять на уникальное или просто полезное имущество.')}&nbsp;
                            {t('А с помощью клана вы можете заработать их существенно больше, приняв участие в клановых боях или построив определенные здания в Военно-Морской базе.')}
                        </p>
                        <div className={styles.resourseWrapper}>
                            <Resourse
                                styles={{ display: 'inline-block' }}
                                icon={'oil'}
                                tooltipBody={
                                    <Tooltip>
                                        <TooltipBody>
                                            {t('Нефть')}&nbsp;-&nbsp;{t('клановый ресурс для постройки зданий в Военно-Морской базе. Зарабатывается при получении контейнеров, а также за некоторые боевые задачи')}
                                        </TooltipBody>
                                    </Tooltip>
                                }
                            />
                            <Resourse
                                styles={{ display: 'inline-block' }}
                                icon={'coal'}
                                tooltipBody={
                                    <Tooltip>
                                        <TooltipBody>
                                            {t('Уголь')}&nbsp;-&nbsp;{t('персональный ресурс, который обменивается на большинство товаров в Арсенале. Его можно получить из контейнеров, а также за различные боевые задачи')}
                                        </TooltipBody>
                                    </Tooltip>
                                }
                            />
                            <Resourse
                                icon={'steel'}
                                tooltipBody={
                                    <Tooltip>
                                        <TooltipBody>
                                            {
                                                t('Сталь')}&nbsp;-&nbsp;{t('персональный ресурс, который обменивается на некоторые корабли в Арсенале, а также может быть конвертирован в значительное количество угля. '
                                                    + 'Его можно получить в клановых и ранговых боях, а также в суперконтейнерах.')
                                            }
                                        </TooltipBody>
                                    </Tooltip>
                                }
                            />
                            <Resourse
                                icon={'clan-token'}
                                tooltipBody={
                                    <Tooltip>
                                        <TooltipBody>
                                            {t('Клановые жетоны - можно получить за победы в клановых боях, играя в лиге Тайфуна.')}
                                        </TooltipBody>
                                    </Tooltip>
                                }
                            />
                            <Resourse
                                icon={'rank-token'}
                                tooltipBody={
                                    <Tooltip>
                                        <TooltipBody>
                                            {t('Ранговые жетоны - можно получить за достижение 1 ранга в ранговых боях.')}
                                        </TooltipBody>
                                    </Tooltip>
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    _getRecommendationsSlide = () => {
        return (
            <div className={styles.slide}>
                <div className={styles.slideContentWrapper}>
                    <div className={styles.titleWrapper}>
                        <h1 className={styles.title}>{t('Подбор клана')}</h1>
                    </div>
                    <div className={styles.searchIconWrapper} />
                    <div className={styles.descriptionWrapper}>
                        <h2 className={styles.secondTitle}>{t('Рекомендательная система')}</h2>
                        <p className={styles.descriptionText}>{t('Хотите вступить в клан, который регулярно участвует в клановых боях или просто найти товарищей для отрядной игры?')}</p>
                        <p className={styles.descriptionText}>{t('Тогда смело нажимайте кнопку "хочу в клан" и вам подберут несколько наиболее подходящих вам кланов, на основе ваших игровых предпочтений и личной статистики.')}</p>
                    </div>
                    <ButtonPromo
                        onClick={this.props.navigateToRecommendations}
                        isCenter={true}
                    >
                        {t('Хочу в клан')}
                    </ButtonPromo>
                </div>
            </div>
        )
    }


    render() {
        const isOpenedBg = this.props.promoInitialSlide === 1
        const showArrows = this.props.activeSlide === 1
        return (
            <div className={styles.wrapper}>
                <Background isOpened={isOpenedBg} />

                <Slider
                    prevArrow={<PrevArrow showPrev={this.props.goToFirstSlide} />}
                    nextArrow={<NextArrow showNext={this.props.goToSecondSlide} />}
                    dots={false}
                    swipe={false}
                    fade={false}
                    initialSlide={this.props.promoInitialSlide}
                    infinite={false}
                    speed={600}
                    ref={this.props.SetSliderRef}
                    beforeChange={this.props.beforeChange}
                    afterChange={this.props.afterChange}
                >
                    <div>
                        {this._getFirstSlide()}
                    </div>
                    {anyClanRecIsEnabled ? (
                        <div>
                            {this._getSecondSlide()}
                        </div>
                    ) : null}
                </Slider>
            </div>
        )
    }
}

export default ViewPromo